module.exports = __webpack_public_path__ + "img/95-9458a4.png";